const BASE_API_URL = process.env.NODE_ENV === 'production' ? 'https://api.jointhor.com/' : 'http://localhost:3001/';
const MAX_RESULTS = 10;
const DEFAULT_TIMEOUT = 5000;

export { BASE_API_URL, MAX_RESULTS, DEFAULT_TIMEOUT };
